import { useParams } from "react-router-dom";
import UserForm, { UserFormData } from "@/Components/Forms/UserForm";
import PageLayout from "@/Themes/Default/Layouts/PageLayout";
import { useQueryClient } from "@tanstack/react-query";
import { useToastMessagesStore } from "@/Stores/ToastMessagesStore";
import { QueryKeys } from "@/Service/Api/V1/QueryKeys/QueryKeys";
import { useGetUser } from "@/Service/Api/V1/ApiHooks/Users/useGetUser";
import { useUpdateUser } from "@/Service/Api/V1/ApiHooks/Users/useUpdateUser";
import { can } from "@/Util/permissionChecks";

const UserPage = () => {
    const queryClient = useQueryClient();
    const addToastMessage = useToastMessagesStore((state) => state.addToastMessage);

    const { userId } = useParams();
    const { data: user } = useGetUser({
        requestParams: {
            user_id: Number(userId)
        },
        enabled: !!userId
    });
    const { mutateAsync: updateUser, isPending } = useUpdateUser();

    const handleUpdateUser = async (data: UserFormData) => {
        await updateUser({
            user_id: user?.id as number,
            UpdateUserRequest: {
                ...data,
                id: user?.id as number
            }
        }, {
            onSuccess: async () => {
                await queryClient.invalidateQueries({
                    queryKey: QueryKeys.users._def
                });
                addToastMessage({
                    severity: 'success',
                    summary: 'User updated',
                    detail: 'User has been updated successfully',
                });
            },
        });
    };

    return (
        <PageLayout>
            <UserForm
                initFormData={user}
                onSubmit={handleUpdateUser}
                isProcessing={isPending}
                onSubmitButtonLabel='Update user'
                onSubmitButtonDisabled={!can('edit:user')}
            />
        </PageLayout>
    );
};
export default UserPage;